import type { RecordStatusFilter } from '@/types/record-status'
import type { PostgrestFilterBuilder } from '@supabase/postgrest-js'

/**
 * Applies the record status filter to a Supabase query builder.
 * - 'active' (default): .is('deleted_at', null)
 * - 'all': no filter applied
 * - 'deleted': .not('deleted_at', 'is', null)
 */
export function applyRecordStatusFilter<
  Schema extends Record<string, unknown>,
  Row extends Record<string, unknown>,
  Relationships,
  Result,
>(
  query: PostgrestFilterBuilder<Schema, Row, Result, Relationships>,
  recordStatus: RecordStatusFilter = 'active'
): PostgrestFilterBuilder<Schema, Row, Result, Relationships> {
  if (recordStatus === 'active') {
    return query.is('deleted_at' as keyof Row & string, null)
  }
  if (recordStatus === 'deleted') {
    return query.not('deleted_at' as keyof Row & string, 'is', null)
  }
  // 'all' — no filter
  return query
}
